import { baseUrl_SPB } from '../BaseUrl';

export default async function AddBrandImage(formData, token) {
    const endpoints = [
        '/api/v1/user/addbrandimage',
        '/api/v1/user/uploadbrandimage',
    ];

    let lastError = null;

    for (const endpoint of endpoints) {
        try {
            const response = await fetch(`${baseUrl_SPB}${endpoint}`, {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + token,
                },
                body: formData,
            });

            if (!response.ok) {
                lastError = new Error(`Upload failed at ${endpoint}`);
                continue;
            }

            return response.json();
        } catch (error) {
            lastError = error;
        }
    }

    if (lastError) {
        throw lastError;
    }

    throw new Error('Brand image upload failed');
}